import { ApisauceInstance } from 'apisauce';

/**
 * Unified override write. Replaces the complete override state for a bonus
 * dataset record (criteria, qualifier, value, reward) in one call, plus the
 * `comment` and `reasonCodes` recorded once for the whole change. This is a
 * REPLACE, not a merge — the caller must pass the full desired state.
 *
 * Supersedes putDriverOverride + putRewardOverride/deleteRewardOverride.
 */
const putDriverOverrides = ({
  api,
  driver,
  bonusProgramId,
  intervalId,
  bonusDatasetRecordId,
  body,
}: {
  api: ApisauceInstance;
  driver: string;
  bonusProgramId: string;
  intervalId: string;
  bonusDatasetRecordId: string;
  body: BonusTypes.Overrides.UnifiedOverridesRequest;
}) => {
  return api.put<BonusTypes.Overrides.UnifiedOverridesResponse>(
    `/v1/driver_bonus/overrides?driver=${driver}&period=${intervalId}&driver_bonus_program_id=${bonusProgramId}&bonus_dataset_record_id=${bonusDatasetRecordId}`,
    body,
  );
};

export default putDriverOverrides;
